import React, { useEffect, useState } from 'react';
import { Route as ReactRoute, Routes, useMatch } from 'react-router-dom';
import { normalizeURL } from '@philips-internal/oswald-common-utils';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { RouteContext } from '@philips-internal/oswald-ui-core/lib/component/index.js';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { StatefulFragment } from '@philips-internal/oswald-ui-engine';
import { getRoutes } from '../../environment/routes.js';
function removeLeadingSlash(path) {
    if (!path.startsWith('/')) {
        return path;
    }
    return path.replace('/', '');
}
function removeTrailingWildcard(path) {
    if (!path.endsWith('*')) {
        return path;
    }
    return path.replace('/*', '');
}
function preparePath(route, removeSlash = false) {
    if (route.exact) {
        const normalizedPath = normalizeURL(route.path);
        return removeSlash ? removeLeadingSlash(normalizedPath) : normalizedPath;
    }
    const wildcardPath = route.path.endsWith('/')
        ? route.path.concat('*')
        : route.path.concat('/*');
    return removeSlash ? removeLeadingSlash(wildcardPath) : wildcardPath;
}
function combinePaths(parentPath, path) {
    const normalizedParent = removeTrailingWildcard(parentPath);
    const normalizedPath = removeLeadingSlash(path);
    return `${normalizedParent}/${normalizedPath}`;
}
function renderRouteElements(routes, removeLeadingSlash = false, parentPath = '') {
    if (!Array.isArray(routes)) {
        return [];
    }
    return routes.map((route) => {
        const path = preparePath(route, removeLeadingSlash);
        const routeContext = new RouteContext(path, null);
        const element = (React.createElement(RouteContext.Context.Provider, { value: routeContext },
            React.createElement(RouteFragment, { parentPath: parentPath, path: path, route: route })));
        const childrenRoutes = renderRouteElements(route.children, true, combinePaths(parentPath, path));
        return (React.createElement(ReactRoute, { element: element, key: route.id, path: path }, childrenRoutes));
    });
}
function RouteFragment(props) {
    const normalizedParentPath = removeTrailingWildcard(props.parentPath ?? '');
    const normalizedPath = removeTrailingWildcard(removeLeadingSlash(props.path));
    const path = [normalizedParentPath, normalizedPath].join('/');
    const match = useMatch(path);
    useEffect(() => {
        if (match) {
            HistoryService.setMatch(match);
        }
    }, [match]);
    const instanceUUID = `${props.route.id}_${props.route.fragment}`;
    return (React.createElement(StatefulFragment, { disposable: true, fragment: props.route.fragment, instanceUUID: instanceUUID, uuid: props.route.id }));
}
function FoundationRoutes() {
    const [routes, setRoutes] = useState([]);
    const loadRoutes = async () => {
        const routes = await getRoutes();
        setRoutes(routes);
    };
    useEffect(() => {
        void loadRoutes();
    }, []);
    if (routes.length <= 0) {
        return null;
    }
    const routeElements = renderRouteElements(routes);
    return (React.createElement(Routes, null, routeElements));
}
const awesomeProperties = {
    type: ComponentType.NAVIGATION,
};
AwesomeComponent(awesomeProperties)(FoundationRoutes);
export { FoundationRoutes, };
//# sourceMappingURL=foundation-routes.js.map